import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { formatInteger } from '../../utils/numberUtils';

const styles = {
    container: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
    },
    textCenter: {
        textAlign: 'center !important',
    },
};

const DailyOSPBookingsTotals = ({ bookedCalls, availableCalls, forecastCalls }) => {
    const { t } = useTranslation('allBookings');

    return (
        <Stack direction="row">
            <div style={styles.container}>
                <Typography variant="body1">{t('dailyOsp.bookedCalls')}</Typography>
                <Typography variant="h5" sx={styles.textCenter}>
                    <span className="notranslate">{formatInteger(bookedCalls)}</span>
                </Typography>
            </div>
            <div style={styles.container}>
                <Typography variant="body1">{t('dailyOsp.remainingCalls')}</Typography>
                <Typography variant="h5" sx={styles.textCenter}>
                    <span className="notranslate">{formatInteger(availableCalls)}</span>
                </Typography>
            </div>
            <div style={styles.container}>
                <Typography variant="body1">{t('dailyOsp.forecastCalls')}</Typography>
                <Typography variant="h5" sx={styles.textCenter}>
                    <span className="notranslate">{formatInteger(forecastCalls)}</span>
                </Typography>
            </div>
        </Stack>
    );
};

export default DailyOSPBookingsTotals;
